import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminReportFiles = lazy(() => import("@/pages/admin/AdminReportFiles"));

export const Route = createFileRoute("/admin/rapportfiler")({
  component: () => <AdminReportFiles />,
});
